module.exports = __webpack_public_path__ + "img/arrow-down.3d58334d.svg";